<template>
  <div class="s_chat_middle g-flex-column">
    <!-- 头部 -->
    <div class="s-chat-middle-header-container g-flex-align-center">
      <div class="s-add-tag-container g-flex-align-center">
        <!-- <div class="s-add-tag g-flex-align-center">
          <i class="iconfont icon-tianjia"></i>
          <span>添加标签</span>
        </div> -->
      </div>
      <!-- 转接和结束 -->
      <div class="s-right-operate-container g-flex-align-center">
<!--        <div class="s-right-zhuanjie g-flex-align-center g-flex-justify-center" @click="transferClick" v-if="auth.canTransfer">-->
<!--          <span>快捷键</span>-->
<!--          <chat-middle-transfer ref="ChatMiddleTransfer" @emitTransferShow="emitTransferShow"/>-->
<!--        </div>-->
        <div style="width: 100px" class="s-right-zhuanjie">
          <el-dropdown trigger="click" @command="handleShortcutChange">
            <span class="el-dropdown-link">
              发送快捷键<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu>
              <el-dropdown-item command="enter" :disabled="shortcutMode === 'enter'">
                Enter 发送 / Shift + Enter 换行
              </el-dropdown-item>
              <el-dropdown-item command="shiftEnter" :disabled="shortcutMode === 'shiftEnter'">
                Shift + Enter 发送 / Enter 换行
              </el-dropdown-item>
              <el-dropdown-item command="ctrlEnter" :disabled="shortcutMode === 'ctrlEnter'">
                Ctrl + Enter 发送 / Enter 换行
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="s-right-zhuanjie g-flex-align-center g-flex-justify-center" @click="clearChatClick" v-if="auth.canEnd">
          <span>清空记录</span>
        </div>
        <div class="s-right-zhuanjie g-flex-align-center g-flex-justify-center" @click="transferClick" v-if="auth.canTransfer">
          <span>转接</span>
          <chat-middle-transfer ref="ChatMiddleTransfer" @emitTransferShow="emitTransferShow"/>
        </div>
        <div class="s-right-jieshu g-flex-align-center g-flex-justify-center" @click="endChatClick" v-if="auth.canEnd">
          <span>结束</span>
        </div>
      </div>
    </div>

    <!-- 消息列表和输入框容器 -->
    <div class="s-chat-middle-container g-flex-column">

      <!-- 消息列表 -->
      <div class="s-chat-middle-content g-self-scrollbar" id="chatMiddleContent">
        
        <!-- 加载历史消息 -->
        <div class="s-reload-history g-flex-align-center g-flex-justify-center">
          <div class="s-reload-btn" @click="loadHistoryClick">
            <i class="iconfont icon-shangsanjiaoxing"></i>
            <span>{{chatUserInfo.finish ? '没有更多了': '查看之前的会话'}}</span>
          </div>
        </div>

        <!-- 消息列表 -->
        <ul class="s-chat-msg-list">
          <li class="s-chat-msg-item g-flex-column" v-for="(item, index) in msgList" :key="index" :class="item.send_type === 2 ? 'g-flex-align-end' : (item.send_type === 1 ? 'g-flex-align-start' : 's-chat-msg-item-system')">
            <!-- 系统转接消息 -->
            <div class="s-msg-item-sys" v-if="item.send_type === 0">
              {{item.msg}}
            </div>

            <!-- 发送时间 -->
            <div class="s-msg-item-time-name" v-show="item.send_type !== 0">
              <span class="s-msg-item-time">{{formatDate(item.create_time, 'MM-dd hh:mm:ss')}}</span>
              <span class="s-msg-item-name" v-show="item.send_type === 2">{{item.kefu_name}}</span>
            </div>

            <div class="s-msg-item-msg-box g-flex-align-center" v-show="item.send_type !== 0" >
              <div class="s-msg-item-msg" :class="item.send_type === 2 ? 's-i-send-bg': '' ">
                <!-- 发送失败 -->
                <div class="s-item-send-fail" v-show="item.send_type === 2 && item.fail">
                  <i class="iconfont icon-gantanhao"></i>
                </div>

                <div class="s-item-send-del" @click="delMsg(index)" v-show="item.send_type === 2">
                  <i class="el-icon-delete-solid"></i>
                </div>
                <div class="s-item-send-translate" @click="translateMsg(item)"  v-show="item.type === 0 && item.send_type === 1 && !item.translate">
                  <el-button type="text">译</el-button>
<!--                  <i class="el-icon-chat-round"></i>-->
                </div>

                <!-- 是文字 -->
                <div v-html="item.msg" v-if="item.type === 0"></div>
                <div style="border-top: 1px solid #555555;padding-top: 5px;margin-top: 5px;" v-html="item.translate"
                     v-if="item.translate && item.type === 0"></div>

                <!-- 是图片 -->
                <div v-if="item.type === 1" class="s-msg-item-image">
                  <el-image :src="JSON.parse(item.msg).filePath" alt="" fit="cover" :preview-src-list="[JSON.parse(item.msg).filePath]" />
                </div>

                <!-- 是文件 -->
                <div v-if="item.type === 2" class="s-msg-item-file g-flex-align-center">
                  <i class="iconfont icon-wenjian1"></i>
                  <div class="s-file-right">
                    <p class="s-file-right-filename">{{JSON.parse(item.msg).fileName}}</p>
                    <span class="s-file-right-download" @click="downFileClick(item)">立即下载</span>
                  </div>
                </div>

                <!-- 💡 新增：已读回执状态标注（仅在客服自己发送、且发送成功的消息下展示） -->
                <div class="s-kefu-read-status" v-if="item.send_type === 2 && !item.fail">
                  <span :class="item.is_read === 1 ? 's-status-read' : 's-status-unread'">
                    {{ item.is_read === 1 ? '已读' : '未读' }}
                  </span>
                </div>

              </div>
            </div>

          </li>
        </ul>

        <!-- 上传进度条 -->
        <div class="s-chat-uploading-box g-flex-justify-end" v-show="uploadingShow">
          <div class="s-chat-uploading g-flex-align-center">
            <div class="s-uploading-left">
              <i class="iconfont icon-wenjian1"></i>
            </div>
            <div class="s-uploading-right flex-column">
              <div class="s-uploading-filename">{{uploadingInfoObj.name}}</div>
              <div class="s-uploading-percent">
                <el-progress :percentage="percentage" :color="uploadingColor"></el-progress>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- 底部输入消息框 -->
      <div class="s-chat-footer-box">
        <div class="s-chat-footer">
          <!-- 操作 -->
          <div class="s-chat-footer-head g-flex-align-center">
            <div class="s-footer-huifu g-flex-align-center"> 
              <div class="s-footer-huifu-item">回复</div>
            </div>
            <ul class="s-footer-operate-list g-flex-justify-end g-flex-align-center">
              <li class="s-footer-operate-item s-item-biaoqing g-flex-align-center" @click="emojiShow = !emojiShow">
                <i class="iconfont icon-biaoqing" title="表情"></i>
                <!-- 表情组件 -->
                <chat-middle-emoji @emitEmojiSelect="emitEmojiSelect" v-show="emojiShow"/>
              </li>
              <li class="s-footer-operate-item g-flex-align-center" @click="imgUploadClick" v-if="auth.canSendFile">
                <i class="iconfont icon-tupian" title="发送图片"></i>
              </li>
              <li class="s-footer-operate-item g-flex-align-center" @click="fileUploadClick" v-if="auth.canSendFile">
                <i class="iconfont icon-wenjian" title="发送文件"></i>
              </li>
            </ul>
          </div>

          <!-- 输入框 -->
          <div class="s-chat-footer-msg-send">
            <!-- @keyup.enter.native="sendMsgClick"  -->
            <el-input ref="chatInput" @keydown.enter.native.prevent="handleKeyDown" @paste.native="handlePaste" type="textarea" class="g-self-scrollbar" :rows="6" placeholder="请输入" v-model="sendContent"></el-input>
            <el-button type="success" class="s-fanyi-btn" @click="translationClick">翻译</el-button>

            <el-button type="primary" class="s-end-btn" @click="sendMsgClick" v-if="auth.canSend">发送</el-button>
          </div>

        </div>
      </div>

      <!-- 上传组件 -->
      <chat-middle-upload ref="ChatMiddleUpload" :chatUserId="chatUserId" :uploadType="uploadType" :uploadAccept="uploadAccept" @emitStartUpload="emitStartUpload" @emitUploadSuccess="emitUploadSuccess" @emitFailUpload="emitFailUpload"/>

      <!-- 播放音效组件 -->
      <AudioPlay ref="AudioPlay" :allSliceFlag="$global.allSliceFlag"/>
    </div>
  </div>
</template>

<script>
  import Bus from '@/utils/bus.js'
  import ChatMiddleEmoji from '@/views/chat/ChatMiddleEmoji.vue'
  import ChatMiddleUpload from '@/views/chat/ChatMiddleUpload.vue'
  import ChatMiddleTransfer from '@/views/chat/ChatMiddleTransfer.vue'
  import { formatDate } from '@/utils/index.js'
  import {apiSendMsg, apiDelMsg, apiClearMsg, apiGetHistory, apiTranslation, apiTranslationMsg} from '@/utils/api.js'
  export default {
    components: { ChatMiddleEmoji, ChatMiddleUpload, ChatMiddleTransfer },
    props: {
      msgList: {
        type: Array,
        default() {
          return []
        }
      },

      chatUserInfo: {
        type: Object,
        default() {
          return {}
        }
      },
      
      chatUserId: {
        type: Number,
        default() {
          return 0
        }
      }
    },
    data() {
      return {
        auth: {
          canSend: this.$global.ApiList.includes(44),
          canEnd: this.$global.ApiList.includes(53),
          canTransfer: this.$global.ApiList.includes(55),
          canSendFile: this.$global.ApiList.includes(56)
        },
        // 默认模式：'enter','ctrlEnter','shiftEnter',
        shortcutMode: localStorage.getItem('shortcut_mode')??'shiftEnter',
        transferShow: false,

        uploadType: 1,

        loadFlag: true, //节流阀 一次请求是否完毕

        uploadAccept: 'image/jpeg,image/jpg,image/png', //上传的限制类型

        percentage: 0,
        uploadingColor: '#409eff',
        uploadingShow: false,
        uploadingInfoObj: { name: '' },

        timeId: null,

        kefuUserInfo: this.$global.adminUser, //客服信息

        sendContent: '',
        emojiShow: false,

        draftMap: {}, // 草稿存储 { chatUserId: content }
      }
    },
    watch: {
      // 监听用户切换，保存和恢复草稿
      chatUserId(newId, oldId) {
        // 保存旧用户的草稿
        if (oldId && this.sendContent.trim()) {
          this.$set(this.draftMap, oldId, this.sendContent)
        } else if (oldId) {
          // 如果内容为空，删除草稿
          this.$delete(this.draftMap, oldId)
        }
        // 恢复新用户的草稿
        if (newId && this.draftMap[newId]) {
          this.sendContent = this.draftMap[newId]
        } else {
          this.sendContent = ''
        }
      }
    },
    mounted() {
      Bus.$on('busQuickItem', (val) => {
        this.sendContent+= val.msg
      })
    },
    beforeDestroy() {
      Bus.$off('busQuickItem')
    },
    methods: {
      formatDate,
      // replaceNewline(content) {
      //   return content.replace(/\n/g, "<br>");
      // },
      // 新增粘贴监听
      handlePaste(event) {
        // 权限校验
        if (!this.auth.canSendFile) {
          this.$message.warning('您没有发送文件的权限');
          return;
        }

        const clipboardData = event.clipboardData || window.window.clipboardData;
        if (!clipboardData) return;

        // 优先读取 clipboardData.files 列表
        if (clipboardData.files && clipboardData.files.length > 0) {
          const rawFile = clipboardData.files[0];
          const isImage = rawFile.type.indexOf('image/') !== -1;

          // 如果是普通文件，保持原样（或者你也可以为文件也加一个确认弹窗）
          if (!isImage) {
            event.preventDefault();
            this.uploadType = 2;
            this.uploadAccept = '*/*';
            this.$nextTick(() => {
              if (this.$refs.ChatMiddleUpload) {
                this.$refs.ChatMiddleUpload.uploadFileByFileObject(rawFile);
              }
            });
            return;
          }

          // 如果是图片，拦截默认粘贴并进入“弹窗预览确认”流程
          event.preventDefault();

          let file = rawFile;
          if (rawFile.name === 'image.png' || !rawFile.name) {
            file = new File([rawFile], `screenshot_${Date.now()}.png`, { type: rawFile.type });
          }

          // 1. 生成本地临时的预览 URL（不消耗网络流量）
          const previewUrl = window.URL.createObjectURL(file);

          // 2. 借助 Element UI 的 $msgbox 渲染图片预览弹窗
          const h = this.$createElement;
          this.$msgbox({
            title: '发送图片确认',
            // 使用 VNode 动态渲染图片样式，限制最大宽高防止大图撑破弹窗
            message: h('div', { style: 'text-align: center; padding: 10px 0;' }, [
              h('img', {
                attrs: { src: previewUrl },
                style: 'max-width: 100%; max-height: 300px; border-radius: 4px; box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);'
              }),
              // h('p', { style: 'margin-top: 15px; color: #606266; font-size: 14px;' }, '您确认要发送这张图片给客户吗？')
            ]),
            showCancelButton: true,
            confirmButtonText: '立即发送',
            cancelButtonText: '取消',
            beforeClose: (action, instance, done) => {
              if (action === 'confirm') {
                // 3. 用户点击确认，正式切换状态并调用子组件上传
                this.uploadType = 1;
                this.uploadAccept = 'image/*';

                this.$nextTick(() => {
                  if (this.$refs.ChatMiddleUpload && typeof this.$refs.ChatMiddleUpload.uploadFileByFileObject === 'function') {
                    this.$refs.ChatMiddleUpload.uploadFileByFileObject(file);
                  }
                });
              }
              // 4. 无论确认还是取消，都释放内存并关闭弹窗
              window.URL.revokeObjectURL(previewUrl);
              done();
            }
          }).catch(() => {
            // 捕获点击取消或关闭弹窗的异常，防止控制台报 Uncaught (in promise)
            window.URL.revokeObjectURL(previewUrl);
          });

          return;
        }

        // 降级备用方案（针对只支持 items 的极少数旧环境，同样加入弹窗）
        const items = clipboardData.items;
        if (items) {
          for (let i = 0; i < items.length; i++) {
            if (items[i].kind === 'file') {
              const file = items[i].getAsFile();
              if (!file) continue;
              const isImg = file.type.indexOf('image/') !== -1;

              if (isImg) {
                event.preventDefault();
                const previewUrl = window.URL.createObjectURL(file);
                const h = this.$createElement;
                this.$msgbox({
                  title: '发送图片确认',
                  message: h('div', { style: 'text-align: center;' }, [
                    h('img', { attrs: { src: previewUrl }, style: 'max-width: 100%; max-height: 260px;' }),
                    h('p', { style: 'margin-top: 10px;' }, '确认发送该图片？')
                  ]),
                  showCancelButton: true,
                  confirmButtonText: '发送',
                  cancelButtonText: '取消'
                }).then(() => {
                  this.uploadType = 1;
                  this.uploadAccept = 'image/*';
                  this.$nextTick(() => {
                    this.$refs.ChatMiddleUpload.uploadFileByFileObject(file);
                    window.URL.revokeObjectURL(previewUrl);
                  });
                }).catch(() => {
                  window.URL.revokeObjectURL(previewUrl);
                });
                break;
              }
            }
          }
        }
      },

      // 点击翻译
      async translationClick() {
        if(!this.sendContent.trim().length) return
        let loading = this.$loading()
        const { success, data } = await apiTranslation({ msg: this.sendContent })
        loading.close()
        if(!success) return
        this.$message.success(data.msg)
        this.sendContent = data.data
      },
      //切换快捷键
      async handleShortcutChange(command) {
        this.shortcutMode = command;
        localStorage.setItem('shortcut_mode', command);
        this.$message.success('快捷键配置已更新');
        //获取聊天框的焦点
        this.$refs.chatInput.focus();
      },

      // 在光标处精准插入换行符
      insertNewLine() {
        // ★ 核心修复：如果当前输入框是空的 (null/undefined/"" )，确保它是一个字符串，防止 substring 报错
        if (!this.sendContent) {
          this.sendContent = '';
        }
        // 获取 el-input 底层的原生 textarea 对象
        const textarea = this.$refs.chatInput.$refs.textarea;
        console.log(textarea)
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const text = this.sendContent;
        // 拼接字符串
        this.sendContent = text.substring(0, start) + '\n' + text.substring(end);

        // 异步重置光标位置
        this.$nextTick(() => {
          textarea.selectionStart = textarea.selectionEnd = start + 1;
          textarea.focus();
        })
      },
      //翻译消息
      async translateMsg(item) {
        if (item.translate) return
        this.$set(item, 'translate', '翻译中...')
        // let loading = this.$loading()
        const {success, data} = await apiTranslationMsg({id: item.id})
        // loading.close()
        if (!success) return this.$set(item, 'translate', '')
        this.$set(item, 'translate', data.translate)
        this.scrollDown50px()
      },

      delMsg(index) {
        if(this.msgList[index].fail){
          this.msgList.splice(index, 1)
          return
        }
        this.$confirm('确认撤回消息?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const {success} = await apiDelMsg({id: this.msgList[index].id})
          if (!success) return
          this.msgList.splice(index, 1)
        })
      },
      // 点击转接客服
      transferClick() {
        this.transferShow = !this.transferShow
        this.$refs.ChatMiddleTransfer.onShow(this.transferShow, this.chatUserId)
      },

      // 转接成功触发
      emitTransferShow(val) {
        this.transferShow = val
        this.$emit('emitTransferDelete')
      },

      // 点击结束会话
      endChatClick() {
          this.$confirm('确认关闭会话?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=> {
          this.$emit('emitChatCloseDialog')
        }).catch(()=>{})
      },

      clearChatClick() {
        this.$confirm('确认清空聊天记录?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const {success} = await apiClearMsg({id: this.chatUserId})
          if (!success) return
          this.msgList = []
        }).catch(() => {
        })
      },

      // 查看历史消息
      async loadHistoryClick() {
        // 是否请求完成 或者是否已经加载完毕了
        if(!this.loadFlag || this.chatUserInfo.finish) return
        this.loadFlag = false
        let msgId = this.msgList[0].id
        const { success, data } = await apiGetHistory({ user_id: this.chatUserId, id: msgId })
        if(!success) return
        if(data.list.length < 5) this.chatUserInfo.finish = true
        this.msgList.reverse()
        data.list.forEach((item) => { 
          this.msgList.push(item) 
        })
        this.msgList.reverse()
        // 请求已完成 可以进行下次
        this.loadFlag = true
      },

      // 修改你的点击下载方法
      async downFileClick(item) {
        try {
          // 1. 解析出文件 URL 和文件名
          const fileData = JSON.parse(item.msg);
          const fileUrl = fileData.filePath;
          // 如果后端没有返回完整文件名，则从 URL 或原本的数据中降级提取
          const fileName = fileData.fileName || fileUrl.substring(fileUrl.lastIndexOf('/') + 1) || 'download_file.txt';

          if (!fileUrl) {
            this.$message.warning('文件路径不存在');
            return;
          }

          // 2. 发起请求，将文件转为 Blob 流（这样可以绕过浏览器的在线预览机制）
          const response = await fetch(fileUrl);
          if (!response.ok) throw new Error('网络请求失败');

          const blob = await response.blob();

          // 3. 动态创建一个隐藏的 <a> 标签触发下载
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = fileName; // 关键：指定 download 属性和文件名，强制浏览器下载

          // 4. 挂载到 DOM 并触发点击，随后立刻销毁和释放内存
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);

        } catch (error) {
          console.error('下载失败:', error);
          // 备用降级方案：如果 fetch 跨域受阻，直接跳转新窗口预览/下载
          const fileData = JSON.parse(item.msg);
          window.open(fileData.filePath, '_blank');
        }
      },

      // 选择表情
      emitEmojiSelect(val) {
        this.sendContent = this.sendContent + ':' + val + ':'
      },
      // 核心键盘事件判断
      handleKeyDown(event) {
        // 忽略中文输入法未确认的 Enter
        if (event.isComposing || event.keyCode === 229) return;
        switch (this.shortcutMode) {
            // 方案 1：Enter 发送 / Shift + Enter 换行
          case 'enter':
            if (event.shiftKey) {
              this.insertNewLine();
            } else {
              event.preventDefault();
              this.sendMsgClick();
            }
            break;
          case 'shiftEnter':
            if (event.shiftKey) {
              this.sendMsgClick();   // 按了 Shift + Enter -> 执行发送
            } else if (!event.ctrlKey && !event.altKey && !event.metaKey) {
              this.insertNewLine(); // 只按了 Enter -> 执行换行
            }
            break;
            // 方案 3：Ctrl + Enter 发送 / Enter 换行
          case 'ctrlEnter':
            if (event.ctrlKey || event.metaKey) {
              this.sendMsgClick();   // 触发发送
            } else if (!event.shiftKey && !event.altKey) {
              this.insertNewLine(); // 触发换行
            }
            break;
        }
      },
      // onShiftEnterKeyDown(event) {
      //   if (event.keyCode === 13) {
      //     // 处理 "enter"
      //     this.sendMsgClick()
      //   }
      //   //'Shift + Enter键' 发送
      //   // if (event.keyCode === 13 && event.shiftKey) {
      //   //   // 处理 "shift+enter" 组合按键
      //   //   this.sendMsgClick()
      //   // }
      // },
      // 发送消息
      async sendMsgClick() {
        // send_type 0 系统
        // send_type 1 客户发送
        // send_type 2 客服发送
        // type 0 消息
        // type 1 图片
        // type 2 文件
        if(!this.auth.canSend) return
        if(!this.sendContent.trim().length) return
        let htmlStr = this.sendContent.replace(/:[a-z_]*?:/g, this.createEmoji)
        htmlStr = htmlStr.replace(/\n/g, "<br>");
        let sendItem = { is_read:0, kefu_name: this.kefuUserInfo.name, msg: htmlStr, send_type: 2, type: 0, create_time: parseInt(new Date().getTime() / 1000), id: this.chatUserId }
        this.msgList.push(sendItem)
        this.$refs.AudioPlay.sendMsgPlay()
        this.emojiShow = false
        this.sendContent = ""
        // 发送成功后清除该用户的草稿
        this.$delete(this.draftMap, this.chatUserId)
        const { success,data } = await apiSendMsg(sendItem).catch(()=> {
          this.$set(this.msgList[this.msgList.indexOf(sendItem)], 'fail', true) 
          return false
        })
        // 发送失败  增加fail字段设置为true
        if(!success) return this.$set(this.msgList[this.msgList.indexOf(sendItem)], 'fail', true)
        sendItem.id = data.data.id
        //sendItem.is_read = data.data.is_read
        this.scrollToBottom()
      },
      

      // 生成表情
      createEmoji(word) {
        // 生成html
        const type = word.substring(1, word.length - 1);
        return `<span class="__KEFU__emoji-${type}" ></span>`;
      },


      // 点击发送图片
      imgUploadClick() {
        this.uploadType = 1
        this.uploadAccept = 'image/jpeg,image/jpg,image/png'
        this.$nextTick(() => {
         document.getElementById('s-chat-middle-upload-file').click()
        })
      },

      // 点击发送文件
      fileUploadClick() {
        this.uploadType = 2
        this.uploadAccept = ''
        this.$nextTick(() => {
         document.getElementById('s-chat-middle-upload-file').click()
        })
      },

      // 开始上传
      emitStartUpload(file) {
        this.percentage = 0
        // console.log('开始上传', file)
        this.uploadingShow = true
        this.uploadingInfoObj.name = file.name
        this.scrollToBottom()
        this.timeId = setInterval(() => {
          if(this.percentage === 95) {
            clearInterval(this.timeId)
            return
          }
          this.percentage+=1
        }, 100);
      },

      // 上传成功
      emitUploadSuccess(val) {
        // 先深拷贝一份以防被新上传的覆盖
        let item = JSON.parse(JSON.stringify(val))
        clearInterval(this.timeId)
        this.percentage = 100
        this.uploadingShow = false
        // console.log(item)
        // 将里面的msg 进行序列化， 在html上进行反序列化操作
        item.msg = JSON.stringify(item.msg)
        this.msgList.push(item)
        this.scrollToBottom()
      },  

      // 上传失败
      emitFailUpload() {
        clearInterval(this.timeId)
        this.percentage = 0
        this.uploadingShow = false
      },

      // 有消息发送时让滚动条始终出现在底部
      scrollToBottom() {
        this.$nextTick(() => {
          let scrollDom = document.getElementById('chatMiddleContent')
          scrollDom.scrollTop = scrollDom.scrollHeight
        })
      },

      // 有消息发送时让滚动条向下滚动50px
      scrollDown50px() {
        this.$nextTick(() => {
          let scrollDom = document.getElementById('chatMiddleContent')
          scrollDom.scrollTop += 50
        })
      },

    },
  }
</script>

<style lang="scss">
.s_chat_middle {
  flex: 1;
  height: 100%;

  /* 客服已读/未读状态的专属样式 */
  .s-kefu-read-status {
    text-align: right;
    font-size: 11px;
    margin-top: 4px;
    user-select: none;
    line-height: 1;
  }

  /* 未读状态：优雅的淡灰色 */
  .s-status-unread {
    color: #a8abb2;
  }

  /* 已读状态：代表成功的清新浅绿色 */
  .s-status-read {
    color: #67c23a;
    font-weight: 500;
  }

  /* 💡 功能二配套：如果消息被撤回/删除，给整体增加一个淡出变灰的视觉类（可选） */
  .s-msg-withdrawn {
    opacity: 0.5;
    filter: grayscale(100%);
  }

  .el-button--primary {
    background: $mainBlue;
  }
  // 头部
  .s-chat-middle-header-container {
    background: $white;
    height: 60px;
    max-height: 60px;
    border-left: 1px solid $chatContainerBg;
    border-right: 1px solid $chatContainerBg;
    border-bottom: 1px solid $chatContainerBg;
    //添加标签
    .s-add-tag-container {
      
      flex: 1;
      padding-left: 16px;
      .s-add-tag {
        cursor: pointer;
        padding: 0px 8px;
        border: 1px solid rgba(4, 15, 66, 0.2);
        color: $fontColor;
        font-size: $most-font-size;
        border-radius: 4px;
        line-height: 22px;
        i {
          color: $noActiveFontColor;
          font-size: 20px;
        }
      }
    }
    // 转接 结束
    .s-right-operate-container {
      border-left: 1px solid $chatContainerBg;
      height: 100%;
      div {
        cursor: pointer;
        span {
          font-size: $most-font-size;
          color: $fontColor;
        }
      }
      .s-right-zhuanjie {
        padding: 5px 10px;
        position: relative;
        width: 70px;
        border-right: 1px solid $chatContainerBg;
      }
      .s-right-jieshu {
        width: 70px;
        padding: 5px 10px;
      }
    }
  
  }
  
  // 消息列表和输入框容器 
  .s-chat-middle-container {
    flex: 1;
    overflow-y: auto;
    // 消息列表
    .s-chat-middle-content {
      padding: 10px 16px;
      flex: 1;
      overflow-y: auto;
      // 加载历史消息
      .s-reload-history {
        padding-bottom: 10px;
        margin-top: -10px;
        .s-reload-btn {
          background: $white;
          padding: 6px 10px;
          border-radius: 0 0 4px 4px;
          box-shadow: 0 0 20px 0 rgba(52, 63, 75, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.04);
          cursor: pointer;
          color: $mainBlue;
          font-size: $most-font-size;
          i {
            font-size: 16px;
            padding-right: 10px;
          }
        }
      }

      // 聊天列表
      .s-chat-msg-list {
        margin: 30px 0;
        margin-bottom: 10px;
        .s-chat-msg-item {
          padding-bottom: 15px;
          &.s-chat-msg-item-system {
            .s-msg-item-sys {
              color: $mainBlue;
              font-size: $small-more-font-size;
              text-align: center;
            }
          }
          .s-msg-item-time-name {
            font-size: $most-font-size;
            .s-msg-item-time {
              color: $noActiveFontColor;
            }
            .s-msg-item-name {
              padding-left: 5px;
              color: $fontColor;
            }
          }
        }
        // 消息
        .s-msg-item-msg-box {
          padding-top: 8px;
          .s-msg-item-msg {
            background: $msgBgColor;
            padding: 10px 12px;
            max-width: 450px;
            word-break: break-all;
            border-radius: 4px;
            color: $fontColor;
            font-size: $small-more-font-size;
            line-height: 24px;
            position: relative;
            &.s-i-send-bg {
              background: $white;
            }
            .s-item-send-fail {
              position: absolute;
              left: -10px;
              top: 50%;
              transform: translateX(-100%) translateY(-50%);
              i {
                color: red;
              }
            }
            .s-item-send-del{
              position: absolute;
              cursor: pointer;
              left: -10px;
              top: 50%;
              transform: translateX(-100%) translateY(-50%);
              i {
                color: #6EB1FA;
              }
              font-size: 18px;
            }
            .s-item-send-translate{
              position: absolute;
              cursor: pointer;
              right: -45px;
              top: 50%;
              transform: translateX(-100%) translateY(-50%);
              i {
                color: #6EB1FA;
              }
              font-size: 18px;
            }
            // 图片
            .s-msg-item-image {
              img {
                max-width: 420px;
                vertical-align: middle;
                object-fit: cover;
              }
            }

            // 文件
            .s-msg-item-file {
              min-width: 180px;
              .icon-wenjian1 {
                font-size: 40px;
              }
              .s-file-right {
                flex: 1;
                padding-left: 10px;
                p {
                  font-size: $small-font-size;
                  color: $fontColor;
                  max-width: 300px;
                  @include textEllipsis();
                }
                span {
                  cursor: pointer;
                  font-size: $small-more-font-size;
                  color: $mainBlue;
                }
              }
            }
          }
        }
      }

      // 上传进度条
      .s-chat-uploading-box {
        padding: 10px 0px;
        width: 100%;
        .s-chat-uploading {
          border-radius: 4px;
          min-width: 180px;
          max-width: 320px;
          padding: 10px 12px;
          background: $white;
          .s-uploading-left {
            i {
              font-size: 40px;
            }
          }
          .s-uploading-right {
            padding-left: 10px;
            flex: 1;
            .s-uploading-filename {
              width: 180px;
              @include textEllipsis()
            }
          }
        }
      }
    }

    // 底部输入消息框 
    .s-chat-footer-box {
      padding: 0 16px 16px;
      .s-chat-footer {
        background: $white;
        // height: 140px;
        border-radius: 6px;
        box-shadow: 0 1px 8px 1px rgba(53, 56, 63, 0.1);
        // 操作
        .s-chat-footer-head {
          height: 40px;
          padding: 0 14px;
          padding-right: 40px;
          border-bottom: 1px solid $chatContainerBg;
          .s-footer-huifu {
            .s-footer-huifu-item {
              position: relative;
              padding: 10px 10px;
              color: $fontColor;
              font-size: $small-more-font-size;
              &::before {
                position: absolute;
                width: 100%;
                background: $mainBlue;
                height: 2px;
                content: "";
                bottom: 0;
                left: 0;
              }
            }
          }
          .s-footer-operate-list {
            flex: 1;
            height: 100%;
            .s-footer-operate-item {
              height: 100%;
              padding-right: 30px;
              &.s-item-biaoqing {
                position: relative;
                padding-left: 30px;
              }
              i {
                font-size: 20px;
                cursor: pointer;
                &:hover {
                  color: $mainBlue;
                }
              }
            }

          }
        }
        // 发送消息的input和按钮
        .s-chat-footer-msg-send {
          position: relative;
          padding-bottom: 40px;
          .el-textarea__inner {
            white-space: pre-wrap;
            width: 100%;
            border: none;
            outline: none;
            resize: none;
            color: $fontColor;
          }
          .s-fanyi-btn {
            position: absolute;
            bottom: 10px;
            left: 10px;
            padding: 8px 16px;
          }
          .s-end-btn {
            position: absolute;
            bottom: 10px;
            right: 10px;
            background: $mainBlue;
            padding: 8px 16px;
          }
        }
      }
    }
  }
}
</style>